var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSummaryExternalDispatches(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9231 0H0V16.9231H3.07692C3.07692 18.6225 4.45451 20 6.15385 20C7.85318 20 9.23077 18.6225 9.23077 16.9231H15.3846C15.3846 18.6225 16.7622 20 18.4615 20C20.1609 20 21.5385 18.6225 21.5385 16.9231H24.6154V9.23077C24.6154 6.68177 22.5491 4.61538 20 4.61538H16.9231V0ZM16.9231 7.69231V10.7692H21.5385V7.69231H16.9231Z",
    fill: "#E16C00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryExternalDispatches);
export default __webpack_public_path__ + "static/media/summary-external-dispatches.7d1e81d4.svg";
export { ForwardRef as ReactComponent };